import React, { useContext } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useHistory } from "react-router-dom";

import "react-perfect-scrollbar/dist/css/styles.css";
import { OrderItemCardWrap } from "../../orderHistory.styles";
import { NormalText, SemiBoldText } from "../../../../common/common.styles";
import { formatKoboBalance } from "../../../../../../utils/utilityFunctions";
import { GreenPlusIcon } from "../../../../common/assets/icons/orderHistoryIcons";
import { ActionTypes, ChargeItemsContext } from "../../../catalogue/context";

const OrderItems = ({ orderData }) => {
    const { contextDispatch } = useContext(ChargeItemsContext);
    const history = useHistory();

    const handleAddToCatalogue = () => {
        contextDispatch({
            type: ActionTypes.UPDATE_SAVED_ORDER,
            payload: orderData,
        });
        history.push({
            pathname: "/sales/catalogue",
            state: {
                orderName: orderData?.name,
            },
        });
    };
    return (
        <PerfectScrollbar className="order-history__order-detail-item">
            {orderData?.items?.map((item) => (
                <OrderItemCardWrap key={item.id + item.name}>
                    <SemiBoldText>
                        {item.name} <span>{item.quantity > 1 && `(x${item.quantity})`}</span>
                    </SemiBoldText>
                    <NormalText>{formatKoboBalance(item.unitPrice)}</NormalText>
                </OrderItemCardWrap>
            ))}
            {orderData?.status === 2 && (
                <div className="order-history__add-item" onClick={handleAddToCatalogue}>
                    <div>
                        <GreenPlusIcon />
                    </div>
                    <NormalText>Edit Items</NormalText>
                </div>
            )}
        </PerfectScrollbar>
    );
};

export default OrderItems;
